'use client';

import type { MeasuredLineLengths } from './xychart-canvas-model';
import { XYChartLineSeriesItem } from './XYChartLineSeriesItem';
import type { XYChartLinePathNodeInput } from './useXYChartLinePathLengths';
import type { XYChartSeriesLayout } from './xychart-types';

export interface XYChartLineSeriesLayerProps {
  series: XYChartSeriesLayout[];
  safeId: string;
  hoveredCategoryIndex: number | null;
  pathLengths: MeasuredLineLengths;
  seriesOpacityFor: (seriesIndex: number) => number;
  onLinePathNode: (input: XYChartLinePathNodeInput) => void;
}

export function XYChartLineSeriesLayer({
  series,
  safeId,
  hoveredCategoryIndex,
  pathLengths,
  seriesOpacityFor,
  onLinePathNode,
}: XYChartLineSeriesLayerProps) {
  return (
    <>
      {series.map((seriesLayout) => (
        <XYChartLineSeriesItem
          key={`line-${seriesLayout.seriesIndex}`}
          series={seriesLayout}
          safeId={safeId}
          hoveredCategoryIndex={hoveredCategoryIndex}
          pathLengths={pathLengths}
          seriesOpacity={seriesOpacityFor(seriesLayout.seriesIndex)}
          onLinePathNode={onLinePathNode}
        />
      ))}
    </>
  );
}
